import { type HTMLAttributes, type PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { COMMON_MOBILE_BREAKPOINT } from '@elfsight/lib-utils';

type BlockProps = HTMLAttributes<HTMLDivElement> &
  PropsWithChildren<{
    withTitle?: boolean;
  }>;

export function Block({
  children,
  withTitle = false,
  ...forwardingProps
}: BlockProps) {
  return (
    <Container {...forwardingProps} $withTitle={withTitle}>
      {children}
    </Container>
  );
}

const Container = styled.div<{
  $withTitle: boolean;
}>`
  ${({ theme, $withTitle }) => css`
    display: flex;
    flex-direction: column;
    gap: ${$withTitle ? 8 : 0}px;
    background-color: ${theme.block.backgroundColor};
    padding: ${$withTitle ? 16 : 8}px 8px;
    border-radius: 20px;
    box-shadow:
      0 2px 6px 0 rgba(0, 0, 0, 0.03),
      0 5px 15px 0 rgba(0, 0, 0, 0.03);

    @media (max-width: ${COMMON_MOBILE_BREAKPOINT}px) {
      border-radius: 0;
      padding-block: 8px;
      box-shadow: none;
    }
  `}
`;
